/* The library's contact details, in one place so the footer, About and
   Resources cannot drift apart again. About can still be overridden by an
   admin in Site Content. */
export const LIBRARY_EMAIL = 'library-smchs@smgeducation.org';
export const LIBRARY_PHONE = '+971 4 337 0252';
export const telHref = (phone: string) => `tel:${phone.replace(/[^+\d]/g, '')}`;
